import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "d-flex justify-content-center border-bottom p-2" }
const _hoisted_2 = { class: "flex-grow-1 text-start" }
const _hoisted_3 = {
  key: 0,
  class: "flex-grow-1 text-center"
}
const _hoisted_4 = { class: "dropdown" }
const _hoisted_5 = {
  class: "btn btn-light btn-sm dropdown-toggle",
  href: "#",
  role: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_6 = { class: "dropdown-menu" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "flex-grow-1 text-center" }
const _hoisted_9 = { class: "flex-grow-1 text-center" }
const _hoisted_10 = { class: "dropdown" }
const _hoisted_11 = {
  class: "btn btn-light btn-sm dropdown-toggle",
  href: "#",
  role: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_12 = { class: "dropdown-menu" }
const _hoisted_13 = { class: "flex-grow-1 text-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Alerts = _resolveComponent("Alerts")!
  const _component_b_icon_arrow_left = _resolveComponent("b-icon-arrow-left")!
  const _component_b_icon_arrow_right = _resolveComponent("b-icon-arrow-right")!
  const _component_g_gantt_row = _resolveComponent("g-gantt-row")!
  const _component_g_gantt_chart = _resolveComponent("g-gantt-chart")!
  const _component_ProjectModal = _resolveComponent("ProjectModal")!
  const _component_CalendarEntryModal = _resolveComponent("CalendarEntryModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Alerts),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("a", {
          class: "btn btn-light btn-sm",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.pastMonth && _ctx.pastMonth(...args)))
        }, [
          _createVNode(_component_b_icon_arrow_left),
          _createTextVNode(" " + _toDisplayString(_ctx.$t("text.previous_month")), 1)
        ]),
        _createElementVNode("a", {
          class: "btn btn-light btn-sm ms-2",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.minusOneWeek && _ctx.minusOneWeek(...args)))
        }, [
          _createVNode(_component_b_icon_arrow_left),
          _createTextVNode(" " + _toDisplayString(_ctx.$t("text.previous_week")), 1)
        ])
      ]),
      (_ctx.boards.length > 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("a", _hoisted_5, _toDisplayString(_ctx.$t("text.current_team")) + ": " + _toDisplayString(_ctx.selectedBoard.principal.name), 1),
              _createElementVNode("ul", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.boards, (board) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: board.id
                  }, [
                    _createElementVNode("a", {
                      class: "dropdown-item",
                      href: "#",
                      onClick: ($event: any) => (_ctx.selectSchedulingBoard(board))
                    }, _toDisplayString(board.principal.name), 9, _hoisted_7)
                  ]))
                }), 128))
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("a", {
          class: "btn btn-secondary btn-sm",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.gotoCurrentWeek && _ctx.gotoCurrentWeek(...args)))
        }, _toDisplayString(_ctx.$t("text.current_week")), 1)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("a", _hoisted_11, _toDisplayString(_ctx.$t("text.calender_size_dropdown_label")) + ": " + _toDisplayString(_ctx.currentChartSizeLabel) + " " + _toDisplayString(_ctx.$t("text.week_unit")), 1),
          _createElementVNode("ul", _hoisted_12, [
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                class: "dropdown-item",
                href: "#",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.changeChartSize(4 * 7)))
              }, " 4 " + _toDisplayString(_ctx.$t("text.week_unit")), 1)
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                class: "dropdown-item",
                href: "#",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.changeChartSize(8 * 7)))
              }, " 8 " + _toDisplayString(_ctx.$t("text.week_unit")), 1)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("a", {
          class: "btn btn-light btn-sm",
          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.plusOneWeek && _ctx.plusOneWeek(...args)))
        }, [
          _createTextVNode(_toDisplayString(_ctx.$t("text.next_week")) + " ", 1),
          _createVNode(_component_b_icon_arrow_right)
        ]),
        _createElementVNode("a", {
          class: "btn btn-light btn-sm ms-2",
          onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.nextMonth && _ctx.nextMonth(...args)))
        }, [
          _createTextVNode(_toDisplayString(_ctx.$t("text.next_month")) + " ", 1),
          _createVNode(_component_b_icon_arrow_right)
        ])
      ])
    ]),
    (!_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_g_gantt_chart, {
          key: 0,
          class: "chart-with-logo",
          "chart-start": _ctx.chart1Start,
          "chart-end": _ctx.chart1End,
          precision: "date",
          "row-height": 40,
          grid: "",
          width: "100%",
          "bar-start": "beginDate",
          "bar-end": "endDate",
          "date-format": _ctx.format,
          "label-column-title": " ",
          onClickBar: _cache[8] || (_cache[8] = ($event: any) => (_ctx.onMouseupBar($event.bar, $event.e, $event.datetime))),
          onMousedownBar: _cache[9] || (_cache[9] = ($event: any) => (_ctx.onMousedownBar($event.bar, $event.e, $event.datetime))),
          onDblclickBar: _cache[10] || (_cache[10] = ($event: any) => (_ctx.onClickBar($event.bar, $event.e, $event.datetime))),
          onMouseenterBar: _cache[11] || (_cache[11] = ($event: any) => (_ctx.onMouseenterBar($event.bar, $event.e))),
          onMouseleaveBar: _cache[12] || (_cache[12] = ($event: any) => (_ctx.onMouseleaveBar($event.bar, $event.e))),
          onDragstartBar: _cache[13] || (_cache[13] = ($event: any) => (_ctx.onDragstartBar($event.bar, $event.e))),
          onDragBar: _cache[14] || (_cache[14] = ($event: any) => (_ctx.onDragBar($event.bar, $event.e))),
          onDragendBar: _cache[15] || (_cache[15] = ($event: any) => (_ctx.onDragendBar($event.bar, $event.e, $event.movedBars))),
          onContextmenuBar: _cache[16] || (_cache[16] = ($event: any) => (_ctx.onContextmenuBar($event.bar, $event.e, $event.datetime))),
          style: {"padding-bottom":"4px"}
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.employees, (employee) => {
              return (_openBlock(), _createBlock(_component_g_gantt_row, {
                label: _ctx.getEmployeeName(employee),
                key: employee.id,
                bars: _ctx.bars1[employee.id],
                "highlight-on-hover": "",
                onClickedTime: ($event: any) => (_ctx.newEntry($event.e, $event.value, employee))
              }, null, 8, ["label", "bars", "onClickedTime"]))
            }), 128)),
            (_ctx.selectedBoard.id)
              ? (_openBlock(), _createBlock(_component_g_gantt_row, {
                  key: 0,
                  label: _ctx.$t('text.open_construction_sites'),
                  bars: _ctx.openProjectsBars1,
                  "highlight-on-hover": "",
                  onClickedTime: _cache[7] || (_cache[7] = ($event: any) => (_ctx.newProject($event.e, $event.value)))
                }, null, 8, ["label", "bars"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["chart-start", "chart-end", "date-format"]))
      : _createCommentVNode("", true),
    (!_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_g_gantt_chart, {
          key: 1,
          "chart-start": _ctx.chart2Start,
          "chart-end": _ctx.chart2End,
          precision: "date",
          "row-height": 40,
          grid: "",
          width: "100%",
          "bar-start": "beginDate",
          "bar-end": "endDate",
          "date-format": _ctx.format,
          "label-column-title": " ",
          onClickBar: _cache[18] || (_cache[18] = ($event: any) => (_ctx.onMouseupBar($event.bar, $event.e, $event.datetime))),
          onMousedownBar: _cache[19] || (_cache[19] = ($event: any) => (_ctx.onMousedownBar($event.bar, $event.e, $event.datetime))),
          onDblclickBar: _cache[20] || (_cache[20] = ($event: any) => (_ctx.onClickBar($event.bar, $event.e, $event.datetime))),
          onMouseenterBar: _cache[21] || (_cache[21] = ($event: any) => (_ctx.onMouseenterBar($event.bar, $event.e))),
          onMouseleaveBar: _cache[22] || (_cache[22] = ($event: any) => (_ctx.onMouseleaveBar($event.bar, $event.e))),
          onDragstartBar: _cache[23] || (_cache[23] = ($event: any) => (_ctx.onDragstartBar($event.bar, $event.e))),
          onDragBar: _cache[24] || (_cache[24] = ($event: any) => (_ctx.onDragBar($event.bar, $event.e))),
          onDragendBar: _cache[25] || (_cache[25] = ($event: any) => (_ctx.onDragendBar($event.bar, $event.e, $event.movedBars))),
          onContextmenuBar: _cache[26] || (_cache[26] = ($event: any) => (_ctx.onContextmenuBar($event.bar, $event.e, $event.datetime)))
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.employees, (employee) => {
              return (_openBlock(), _createBlock(_component_g_gantt_row, {
                label: _ctx.getEmployeeName(employee),
                key: employee.id,
                bars: _ctx.bars2[employee.id],
                "highlight-on-hover": "",
                onClickedTime: ($event: any) => (_ctx.newEntry($event.e, $event.value, employee))
              }, null, 8, ["label", "bars", "onClickedTime"]))
            }), 128)),
            (_ctx.selectedBoard.id)
              ? (_openBlock(), _createBlock(_component_g_gantt_row, {
                  key: 0,
                  label: _ctx.$t('text.open_construction_sites'),
                  bars: _ctx.openProjectsBars2,
                  "highlight-on-hover": "",
                  onClickedTime: _cache[17] || (_cache[17] = ($event: any) => (_ctx.newProject($event.e, $event.value)))
                }, null, 8, ["label", "bars"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["chart-start", "chart-end", "date-format"]))
      : _createCommentVNode("", true),
    _createVNode(_component_ProjectModal, {
      ref: "projectModal",
      "size-class": "modal-lg",
      employees: _ctx.employees,
      onProjectModalSaved: _ctx.reloadDataAndRefreshBoard
    }, null, 8, ["employees", "onProjectModalSaved"]),
    _createVNode(_component_CalendarEntryModal, {
      ref: "calendarEntryModal",
      "size-class": "modal-lg",
      employees: _ctx.employees,
      onCalendarEntryModalSaved: _ctx.reloadDataAndRefreshBoard
    }, null, 8, ["employees", "onCalendarEntryModalSaved"])
  ], 64))
}